<template>
    <div class="hts-company-info">
        <div class="flex items-center justify-start p-3">
            <hi-arrow-left-icon
                class="icon w-10 font-bold cursor-pointer hover:bg-gray-200"
                @click="handleGoBack" />
            <h3 class="text-xl font-bold ml-2">
                {{ `Chi nhánh ${companyBranchInfo.name}` }}
            </h3>
        </div>
        <div class="hts-company-group-ignore-add-group">
            <div class="hts-company-group-ignore-add-group__container-body">
                <hts-card>
                    <template #title>
                        <h3 class="title">
                            <hi-backward-icon class="icon overturned" />
                            <span class="label">
                                {{ $t('labels.invoiceInformation') }}
                            </span>
                        </h3>
                    </template>
                    <template
                        v-if="group.isAdmin || permissions.includes('company_branch_edit_invoice')"
                        #toolbar>
                        <hts-dropdown
                            :options="dropdownOptions"
                            type="text"
                            :label-only-icon="true"
                            color="theme"
                            size="large"
                            prop-option-key="id"
                            prop-option-label="name"
                            icon="hi-ellipsis-vertical-icon"
                            prop-option-icon="hi-pencil-alt-icon"
                            @click="handleEditInvoice" />
                    </template>
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-5">
                        <div>
                            <h3>
                                {{ $t('labels.companyName') }}
                            </h3>
                            <p class="mt-2">
                                {{ companyName }}
                            </p>
                        </div>
                        <div>
                            <h3>
                                {{ $t('labels.invoiceName') }}
                            </h3>
                            <p class="mt-2">
                                {{ invoicingData.name }}
                            </p>
                        </div>
                        <div>
                            <h3>
                                {{ $t('labels.accountNumber') }}
                            </h3>
                            <p class="mt-2">
                                {{ invoicingData.accountNumber }}
                            </p>
                        </div>
                        <div>
                            <h3>
                                {{ $t('labels.accountName') }}
                            </h3>
                            <p class="mt-2">
                                {{ invoicingData.accountName }}
                            </p>
                        </div>
                        <div>
                            <h3>
                                {{ $t('labels.swiftCode') }}
                            </h3>
                            <p class="mt-2">
                                {{ invoicingData.swiftCode }}
                            </p>
                        </div>
                        <div>
                            <h3>
                                {{ $t('labels.address') }}
                            </h3>
                            <p class="mt-2">
                                {{ invoicingData.address }}
                            </p>
                        </div>
                        <div>
                            <h3>
                                {{ $t('labels.taxNumber') }}
                            </h3>
                            <p
                                v-if="invoicingData && invoicingData.phone"
                                class="mt-2">
                                {{ invoicingData.taxNumber }}
                            </p>
                        </div>
                        <div>
                            <h3>
                                {{ $t('labels.phone') }}
                            </h3>
                            <p class="mt-2">
                                {{ invoicingData.phone }}
                            </p>
                        </div>
                    </div>
                </hts-card>
            </div>
        </div>
        <edit-invoice-branch
            :invoice-is-selected-to-edit="invoiceIsSelectedToEdit"
            :show="showSlideOverEditInvoice"
            :size-slide-over="30"
            :company-branch-info="companyBranchInfo"
            @close="showSlideOverEditInvoice = false"
            @refresh="(data:Object)=>onRefresh(data)" />
    </div>
</template>

<script setup lang="ts">
import { IInvoicingInformation } from './imports/invoice-form'
import EditInvoiceBranch from './edit-invoice-branch.vue'
import companyPageTabs from '@/data/company/tabs.json'
const store = $store()
const group = store.system.getGroup
const permissions = ref<Array<String>>([])
onMounted(() => {
  permissions.value = group.permissions
})
const route = useRoute()
const dropdownOptions = [
  {
    id: 1,
    name: `${$t('labels.edit')}`,
    icon: 'hi-pencil-alt-icon',
    action: 'edit'
  }
]
onBeforeMount(() => {
  route.meta.pageTabs = companyPageTabs
  companyName.value = store.system.getCompany.name
})
const props = defineProps({
  invoiceIsSelectedToView: {
    type: Object,
    default: () => {}
  },
  companyBranch: {
    type: Object,
    default: () => {}
  }
})
const { invoiceIsSelectedToView, companyBranch } = toRefs(props)
const showSlideOverEditInvoice = ref(false)
const companyName = ref('')
const invoicingData: any = reactive({})
const companyBranchInfo: { [key: string]: any } = reactive({})
const checkEmptyData = ref(false)
const invoiceIsSelectedToEdit = reactive<IInvoicingInformation>({
  name: '',
  address: '',
  accountNumber: '',
  accountName: '',
  swiftCode: '',
  taxNumber: '',
  phone: ''
})
const handleEditInvoice = () => {
  Object.assign(invoiceIsSelectedToEdit, invoicingData)
  showSlideOverEditInvoice.value = true
}
const onRefresh = (data: { [key: string]: any }) => {
  if (!data) {
    return null
  }
  Object.assign(invoicingData, data)
}
const emits = defineEmits(['back'])
const handleGoBack = () => {
  emits('back')
}
onMounted(() => {
  Object.assign(invoicingData, invoiceIsSelectedToView.value)
  if (!invoicingData) {
    checkEmptyData.value = true
  }
  Object.assign(companyBranchInfo, companyBranch.value)
})
</script>
